import * as Styled from "./style";
import { useMatchMedia } from "~/hooks/use-match-media";

type ItemEpisodeDetailSkeletonProps = {
  /** 表示するスケルトンの要素数 */
  skeletonLength: number;
  /** コンテナの全体の横幅から算出した1アイテムの横幅の比率 */
  oneItemWidthRatio: number;
  /** 1アイテムの高さ */
  itemHeight: number;
  /** 画像の横幅 */
  imageWidth: number;
  /** 画像の縦幅 */
  imageHeight: number;
  /** 1アイテムの余白 */
  padding?: string;
};

/** 作品末端（/detail）のEpisodeで使用する`Skeleton Component` */
export const ItemEpisodeDetailSkeleton = ({
  skeletonLength,
  oneItemWidthRatio,
  itemHeight,
  imageWidth,
  imageHeight,
  padding,
}: ItemEpisodeDetailSkeletonProps) => {
  const { isSpSize } = useMatchMedia();

  return (
    <Styled.DivFlexContainer>
      {[...Array(skeletonLength)].map((_, idx) => {
        return (
          <Styled.DivItemEpisodeSkeletonWrapper
            key={`ItemPackageSkeleton-${idx}`}
            oneItemWidthRatio={oneItemWidthRatio}
            itemHeight={itemHeight}
            padding={padding}
          >
            <Styled.ItemEpisodeSkeletonImg
              type="square"
              width={imageWidth}
              height={imageHeight}
              borderRadius={8}
              delay={idx}
              animType="fade"
            />

            <Styled.DivSkeletonDescriptionWrapper style={{ height: imageHeight }}>
              <Styled.ItemEpisodeDetailSkeleton
                type="square"
                width="80px"
                height="24px"
                borderRadius={8}
                delay={idx}
                animType="fade"
              />
              <Styled.ItemEpisodeDetailSkeleton
                type="square"
                width="50%"
                height="24px"
                borderRadius={8}
                delay={idx}
                animType="fade"
              />
              {!isSpSize && (
                <>
                  <Styled.ItemEpisodeDetailSkeleton
                    type="square"
                    width="100%"
                    height="24px"
                    borderRadius={8}
                    delay={idx}
                    animType="fade"
                  />
                  <Styled.ItemEpisodeDetailSkeleton
                    type="square"
                    width="100%"
                    height="24px"
                    borderRadius={8}
                    delay={idx}
                    animType="fade"
                  />
                </>
              )}
            </Styled.DivSkeletonDescriptionWrapper>
          </Styled.DivItemEpisodeSkeletonWrapper>
        );
      })}
    </Styled.DivFlexContainer>
  );
};
